import { generateId } from '../utils/utils';


/* Example Usage

const selectHtml = new SelectHtml(
    'test-select',
    'testlabel',
    [
        {
            value: 'test1',
            label: 'Test 1',
            selected: true,
        },
        {
            value: 'test2',
            label: 'Test 2',
            disabled: true,
        },
        {
            value: 'test3',
            label: 'Test 3',
        },
    ],
    {
        small: true,
        inline: true,
    }
);

console.log('selectHtml', selectHtml.toString());

*/

export default class SelectHtml {
    constructor(id, label, options, config) {
        this._id = id || generateId();
        this._label = label;
        this._options = options || [];
        this._config = config;
    }

    _getOptionsHtml() {
        return this._options.map((option) => `
            <option value="${option.value}"${option.selected ? ' selected' : ''}${option.disabled ? ' disabled' : ''}>
                ${option.label}
            </option>
        `).join('');
    }

    toString() {
        let inline = true;
        let small = false;

        if (this._config) {
            inline = this._config.inline;
            small = this._config.small;
        }

        return `
        <div class="rfct-select${inline ? ' rfct-select--inline' : ''}${small ? ' rfct-select--small' : ''}">
            ${this._label ? `
                <label class="rfct-select__label" for="${this._id}">
                    ${this._label}
                </label>
            ` : ''}
            <select class="rfct-select__select" id="${this._id}">
                ${this._getOptionsHtml()}
            </select>
        </div>
        `;
    }
}
